namespace Matrix.Data {
    export interface AccountModelTargetForm {
        AccountCode: Serenity.ServiceLookupEditor;
        ModelCode: Serenity.StringEditor;
        TargetCode: Serenity.StringEditor;
        TargetName: Serenity.StringEditor;
        Nominal: Serenity.DecimalEditor;
        Tilt1: Serenity.DecimalEditor;
        Tilt2: Serenity.DecimalEditor;
        Tilt3: Serenity.DecimalEditor;
        Tilt4: Serenity.DecimalEditor;
        Tilt5: Serenity.DecimalEditor;
        Tilt6: Serenity.DecimalEditor;
        Tilt7: Serenity.DecimalEditor;
        Tilt8: Serenity.DecimalEditor;
        Tilt9: Serenity.DecimalEditor;
        Tilt10: Serenity.DecimalEditor;
        Target: Serenity.DecimalEditor;
        LowerLimit: Serenity.DecimalEditor;
        UpperLimit: Serenity.DecimalEditor;
        LowerWarning: Serenity.DecimalEditor;
        UpperWarning: Serenity.DecimalEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class AccountModelTargetForm extends Serenity.PrefixedContext {
        static formKey = 'Data.AccountModelTarget';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountModelTargetForm.init)  {
                AccountModelTargetForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(AccountModelTargetForm, [
                    'AccountCode', w0,
                    'ModelCode', w1,
                    'TargetCode', w1,
                    'TargetName', w1,
                    'Nominal', w2,
                    'Tilt1', w2,
                    'Tilt2', w2,
                    'Tilt3', w2,
                    'Tilt4', w2,
                    'Tilt5', w2,
                    'Tilt6', w2,
                    'Tilt7', w2,
                    'Tilt8', w2,
                    'Tilt9', w2,
                    'Tilt10', w2,
                    'Target', w2,
                    'LowerLimit', w2,
                    'UpperLimit', w2,
                    'LowerWarning', w2,
                    'UpperWarning', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
